import { NEWS } from "@/mock";
import { ArrowUpRight } from "lucide-react";

export default function NewsSection() {
  return (
    <section id="noticias" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-end justify-between mb-14 flex-wrap gap-4">
          <div>
            <span className="text-municipal font-semibold text-sm uppercase tracking-widest">Canal actualidad</span>
            <h2 className="font-heading font-bold text-3xl sm:text-4xl text-municipal mt-3">Noticias destacadas</h2>
          </div>
        </div>
        <div className="grid md:grid-cols-3 gap-8">
          {NEWS.map((n) => (
            <a
              key={n.id}
              href="#"
              className="group bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300"
              data-testid={`news-card-${n.id}`}
            >
              <div className="h-48 overflow-hidden">
                <img
                  src={n.image}
                  alt={n.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-6">
                <span className="text-xs font-semibold text-valoriza-green uppercase tracking-wide">{n.category}</span>
                <h3 className="font-heading font-semibold text-municipal mt-2 leading-snug group-hover:text-dorado transition-colors">
                  {n.title}
                </h3>
                <span className="inline-flex items-center gap-1 text-sm text-gray-400 mt-4">
                  Leer más <ArrowUpRight className="w-3.5 h-3.5" />
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
